<form [formGroup]="form" style="margin:10px 15px;">
  <div class="form-group mb-2">
    <select name="years" id="yearsSelector" formControlName="year" class="form-select">
      <option *ngFor="let year of (years$ | async)" [ngValue]="year">{{year.year}}</option>
    </select>
  </div>
  <div class="form-group mb-2">
    <select name="state" id="statesSelector" formControlName="state" class="form-select">
      <option *ngFor="let state of (states$ | async)" [ngValue]="state">{{state.name}}</option>
    </select>
  </div>
  <div class="form-group mb-2">
    <select name="commoditySelect" id="commoditySelect" formControlName="commoditySelect" class="form-select">
      <option value="" selected="selected">All</option>
      <option *ngFor="let commodity of uniqueCommodities | orderBy: 'CommodityName'" [ngValue]="commodity">{{commodity?.CommodityName}}</option>
    </select>
  </div>
  <div class="form-group" [hidden]="true">
    <select name="county" id="countySelector" formControlName="county" class="form-select">
      <option *ngFor="let county of (counties$ | async)" [ngValue]="county">{{county.Name}}</option>
    </select>
  </div>
</form>
